import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Header2 from './components/Header2';
import Header3 from './components/Header3';
import Header2HE from './components/Header2HE';
import Header3HE from './components/Header3HE';
import Header2TH from './components/Header2TH';
import Header3TH from './components/Header3TH';
import Header2ZH from './components/Header2ZH';
import Header3ZH from './components/Header3ZH';
import Header2KO from './components/Header2KO';
import Header3KO from './components/Header3KO';
import Button from './components/Button';
import CookieBar from './components/CookieBar';
import Footer from './components/Footer';
import FooterPC from './components/FooterPC';
import PositionsEN from './components/PositionsEN';
import PositionsHE from './components/PositionsHE';

import P404page from './components/P404page';

import BringThemHomeNowEN from './components/BringThemHomeNowEN';
import BringThemHomeNowHE from './components/BringThemHomeNowHE';

import Main from './en/Main';
import MainMobile from './en/MainMobile';
import MainHE from './he/MainHE';
import MainMobileHE from './he/MainMobileHE';
import Articles from './en/Articles';
import Discordmods from './en/Discordmods';
import DiscordmodsMobile from './en/DiscordmodsMobile';
import Discordbot from './en/Discordbot';
import OpenParliament from './en/OpenParliament';
import OpenParliamentMobile from './en/OpenParliamentMobile';
import Rules from './en/Rules';

import Election from './en/Election';
import Electionvote from './en/Electionvote';

import Miles from './en/Miles';
import Identities from './en/Identities';
import Partnerships from './en/Partnerships';
import PartnershipsMobile from './en/PartnershipsMobile';
import AboutUs from './en/AboutUs';
import Projects from './en/Projects';
import AddNews from './components/AddNews';
import NewsList from './components/NewsList';
import NewsArticle from './components/NewsArticle';
import TransBase from './en/TransBase';
import PRM from './en/PRM';
import PRMAdmin from './components/PRMAdmin';
import Forums from './components/Forums';
import AdminPage from './components/AdminPage';
import Login from './components/Login';
import Register from './components/Register';
import ChangePassword from './components/ChangePassword';
import HomeAc from './components/HomeAc';
import MilesAc from './components/MilesAc';
import firebase from './firebase';
import RedeemMiles from './components/RedeemMiles';
import CreateBNM from './components/CreateBNM';
import CreateACM from './components/CreateACM';
import CreatePNM from './components/CreatePNM';
import InitializeTransactions from './components/InitializeTransactions';

import PronounsCard from './en/PronounsCard';
import PronounsCardAc from './components/PronounsCardAc';
import ViewUserData from './components/ViewUserData';

import TH from './th/TH';
import THRules from './th/THRules';
import './article.css';
import './layout.css';
import './print.css';
import './variables.css';

const App = () => {
  const [user, setUser] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const [languagePath, setLanguagePath] = useState('');

  // Handle user authentication
  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      setUser(user);
    });
    return () => unsubscribe();
  }, []);

  // Handle screen resizing
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1050);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine language path based on current URL
  const LocationBasedHeader = () => {
    const location = useLocation();
    useEffect(() => {
      const path = location.pathname;
      if (path.startsWith('/he')) {
        setLanguagePath('he');
      } else if (path.startsWith('/th')) {
        setLanguagePath('th');
      } else if (path.startsWith('/zh')) {
        setLanguagePath('zh');
      } else if (path.startsWith('/ko')) {
        setLanguagePath('ko');
      } else {
        setLanguagePath('');
      }
    }, [location.pathname]);

    switch (languagePath) {
      case 'he':
        return isMobile ? <Header3HE /> : <Header2HE />;
      case 'th':
        return isMobile ? <Header3 /> : <Header2 />;
      case 'zh':
        return isMobile ? <Header3 /> : <Header2 />;
      case 'ko':
        return isMobile ? <Header3 /> : <Header2 />;
      default:
        return isMobile ? <Header3 /> : <Header2 />;
    }
  };

  return (<Router>
    <div>
      <LocationBasedHeader />
      
        <Routes>
          <Route path="/account" element={user ? <HomeAc user={user} /> : <Login />} />
          <Route path="/register" element={user ? <HomeAc user={user} /> : <Register />} />
          <Route path="/changepassword" element={user ? <ChangePassword user={user} /> : <Login />} />
          <Route path="/" element={isMobile ? <><MainMobile /><PositionsEN /><BringThemHomeNowEN/></> : <><Main /><PositionsEN/><BringThemHomeNowEN/></>}/>
          <Route path="/he/" element={isMobile ? <><MainMobileHE /><PositionsHE /><BringThemHomeNowHE/></> : <><MainHE /><PositionsHE/><BringThemHomeNowHE/></>} />
          <Route path="/discordmods" element={<Discordmods />} />
          <Route path="/staffs" element={<Discordmods />} />
          <Route path="/discordbot" element={<Discordbot />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/openparliament" element={isMobile ? <><OpenParliamentMobile /></> : <><OpenParliamentMobile /></>} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/election" element={<Election />} />
          <Route path="/election/vote" element={<Electionvote />} />
          <Route
        path="/miles"
        element={
          user ? (
            <>
              <MilesAc user={user} />
            </>
          ) : (
            <Miles />
          )
        }
      />
      <Route
        path="/pronounscard"
        element={
          user ? (
            <>
              <HomeAc user={user} />
            </>
          ) : (
            <PronounsCard />
          )
        }
      />
<Route path="/u/:username" element={<ViewUserData />} /> {/* Dynamic user route */}

{/*testing purpose non auth will be edited*/}
          <Route path="/createbnmenby" element={<CreateBNM />} />
          <Route path="/createacmenby" element={<CreateACM />} />
          <Route path="/createpnmenby" element={<CreatePNM />} />
          <Route path="/identities" element={<Identities />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/transbase" element={<TransBase />} />
          <Route path="/PRM" element={<PRM />} />
          <Route path="/PRMAdmin" element={<PRMAdmin />} />
          <Route path="/th" element={<TH />} />
          <Route path="/th/rules" element={<THRules />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/news/:id" element={<NewsArticle />} />
          <Route path="/news" element={<NewsList />} />
          <Route path="/adminnewsa" element={<AddNews />} />
          <Route path="/misc" element={<P404page />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/forums" element={<Forums />} />
          <Route path="/forums/thailand" element={<P404page />} />
          <Route path="/forums/singapore" element={<P404page />} />
          <Route path="/forums/korea" element={<P404page />} />
          <Route path="/forums/israel" element={<P404page />} />
        </Routes>
      
      {isMobile ? <Footer /> : <FooterPC />}
      <CookieBar />
    </div></Router>
  );
};

export default App;
